<template>
	<PaymentConditionPill
		:height="props.height"
		:width="props.width">
		<template #icon>
			<svg
				width="11"
				height="10"
				class="icon">
				<use xlink:href="#___icon___flex-payment"></use>
			</svg>
		</template>
		<template #content>
			<span>
				{{ props.content.flex_product }}
			</span>
		</template>
	</PaymentConditionPill>
</template>

<script setup lang="ts">
import { defineProps } from "vue"

// Components
import PaymentConditionPill from "./PaymentConditionPill.vue"

interface Props {
	content: { [key: string]: string }
	height?: number
	width?: number
}

const props = defineProps<Props>()
</script>
